import {TextEncoder} from "encoding";
import Bottleneck from "bottleneck";
import Device from "../device.js";


class Module extends Device {
  constructor(serialPort) {
    super(serialPort);

    this.id = "uninitialized";
    this.status = "uninitialized";        
    this.serialPort = serialPort;

    this.limiter = new Bottleneck({
      maxConcurrent: 1,
      minTime: 10
    });    

    /* publicate remote methods to clients */
    jfermi.RM_ezoo2_lowPointCalibration = this.RM_ezoo2_lowPointCalibration.bind(this);
    jfermi.RM_ezoo2_highPointCalibration = this.RM_ezoo2_highPointCalibration.bind(this);
    jfermi.RM_ezoo2_clearCalibration = this.RM_ezoo2_clearCalibration.bind(this);
  }
  async initialize() {
    try {            
      await this.serialPort.open({
        baudRate: 9600,
        dataBits: 8,
        parity: "none",
        stopBits: 1    
      });
      
      /* enable response codes */
      await this.command("*OK,1");

      /* disable continuous reading mode */
      if (await this.command("C,?") != "?C,0")
        await this.command("C,0");

      /* disable percent concentration from output string*/
      if (await this.command("O,?") != "?O,PPT") {
        await this.command("O,PPT,1"); //enable PPT           
        await this.command("O,%,0"); //disable percent concentration
      }

      this.id = await this.command("i");

      this.usbProductName = (await this.serialPort.getInfo()).usbProductName;
	  this.usbSerialNumber = (await this.serialPort.getInfo()).usbSerialNumber;    
      this.name = "ezoo2Sensor";
      
      this.status = "OK";      
    } catch(e) {
      this.status = "Failed";
      throw e;
    }
  }
  async update() {
    try {                    
      this.value = await this.getO2(); 
      this.value *= Math.pow(10, 3);
      this.calibrationStatus = {
        "?CAL,0": "no calibration",
        "?CAL,1": "single point calibration",
        "?CAL,2": "two point calibration"        
      }[await this.command("Cal,?")];
      this.status = "Ok";
    } catch(e) {
      this.status = "Failed";
      throw e;
    }      
  }
  async getO2() {
    var result = await this.command("R");       
    return parseInt(result);
  }
  /* sending new command to the device while waiting for the response may cause concurrency problems           */
  /* so we wrapped the function and limited the maximum number of concurrent calls to 1 with bottlenck library */  
  async command(command) {
    return await this.limiter.schedule(() => this.command_wrapped(command));
  }
  async command_wrapped(command) {
    const encoder = new TextEncoder();
    const writer = this.serialPort.writable.getWriter();
    await writer.write(encoder.encode(`${command}\r`).buffer);
    writer.releaseLock();    
    const reader = this.serialPort.readable.getReader();

    var result = "";
    while (true) {
      const { value, done } = await reader.read();      
      result += String.fromCharCode.apply(null, new Uint8Array(value));      
      if (done || result.endsWith('*OK\r')) {
        // |reader| has been canceled.       
        result = result.replace("*OK\r","");
        result = result.replace("\r","");
        result = result.toUpperCase();
        break;
      }        
    }

    reader.releaseLock();

    return result;
  }
  async RM_ezoo2_lowPointCalibration() {
    await this.command("Cal,0");   
    return true;
  }
  async RM_ezoo2_highPointCalibration(request, ppm) {
    await this.command(`Cal,${ppm/10000}`);   
    return true;    
  }
  async RM_ezoo2_clearCalibration() {
    await this.command("Cal,Clear");   
    return true;    
  }    
  toJSON() {
    return({
      id: this.id,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,      
      status: this.status,
      value: this.value,
      calibrationStatus: this.calibrationStatus
    });
  }
}

export default Module;